<script>
import {hasEditPermission,currentRoleLevelName,trialActiveForClients} from '@/mixins/roleLevelPermissions';
import { mapState } from 'vuex';

export default {
	props: ['agreementData'],
	data() {
		return {
			isViewMode : !hasEditPermission('section-property'),
			showLearnButton: ['client-level-1', 'client-level-2'].includes(currentRoleLevelName)
		};
	},
	computed: {
		...mapState(['currentRoleLevel']),
		cpp() {
			return this.agreementData.cpp
			// return this.agreementData.cpp = this.agreementData.cpp.hasOwnProperty('additionalClausesToRecitals') 
			// 	? this.agreementData.cpp 
			// 	: {...this.agreementData.cpp, additionalClausesToRecitals: []};
		
		},
		clientUserAgreement(){
			return trialActiveForClients() || currentRoleLevelName === 'client-sharing-user';
		},
		isUserSeparatingParty(){
			return this.currentRoleLevel.roleAssociated === 'party'
		},
		dynamicQuestions(){
			if(this.isUserSeparatingParty){
				return {
					equalization: "Will you equalize or keep the Canada Pension Plan credits accumulated by each of you during their relationship?"
				}
			}
			else{
				return {
					equalization: "Will the parties equalize or keep the Canada Pension Plan credits accumulated by each of them during their relationship?"
				}
			}
		}
	},
	mounted(){
		this.agreementData.cpp = this.agreementData.cpp.hasOwnProperty('additionalClausesToRecitals') ? this.agreementData.cpp : {...this.agreementData.cpp, additionalClausesToRecitals: []};
	}
};
</script>

<template>
	<b-card>
		<div slot="header" class="section-heading">
			<h4>CPP</h4>
			<a href="#" onclick="Intercom('showArticle', 11106876)" v-if="this.showLearnButton">Learn &nbsp;<b-icon-book/></a>
		</div>

		<b-alert variant="warning" :show="clientUserAgreement">
			<b>Note:</b> CPP contributions made while you and your spouse or partner lived together
			are usually divided equally at separation, in a process called credit splitting.
			You can choose to split the credits or waive your rights and keep your own. For
			more context, you can request a Statement of Contributions from Service Canada,
			but no further information or calculations are needed to make this decision.
		</b-alert>
		<template v-if="!clientUserAgreement">
			<radio-group
				v-model="cpp.plan"
				reset-undefined
				select
				input-cols="5"
				class="mb-3"
				:label="dynamicQuestions.equalization"
				:options="[
					{ text: 'Keep their own CPP credits', value: 'keep' },
					{ text: 'Equalize their CPP credits', value: 'equalize' },
				]"
				:testid="'CPP-equalization'"
				:length="'long'"
				:disabled="isViewMode"
				:toolTipText="`Equalizing the CPP credits means that you pool your CPP credits
			and share them equally between you. This option is the default under the law.
			Alternatively, you may keep your own credits and waive your right to your
			spouse's credits. Keeping your own credits is a popular choice where each of you
			earned similar incomes during the relationship or both earned greater than the
			maximum contribution amount for the years you were together (see the Knowledge
			Base in this section for more information).`"
		/>

			<additional-clauses :title="'Additional Clauses into Recitals'" :newLabel="'Add Clause to Recitals'" class="mt-2" v-model="cpp.additionalClausesToRecitals" :testid="'CPP-equalization-to-recitals-'"
				:disabled="isViewMode"/>
			<additional-clauses :title="'Additional Clauses into Sections'" :newLabel="'Add Clause to Section'" class="mt-2" v-model="cpp.additionalClauses" :testid="'CPP-equalization-'"
				:disabled="isViewMode"/>
		</template>
	</b-card>
</template>
